import { useState } from "react";
import { CheckCircle2, AlertTriangle } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";

const Toggle = ({ label, hint, checked, onChange, testId }) => (
  <div className="flex items-center justify-between gap-4 rounded-xl border border-white/10 p-4">
    <div><p className="font-semibold">{label}</p><p className="text-xs text-slate-400">{hint}</p></div>
    <Switch data-testid={testId} checked={checked} onCheckedChange={onChange} />
  </div>
);

export const AdminSettings = ({ settings, onSave, mpConfigured }) => {
  const [f, setF] = useState({
    site_name: settings.site_name, tagline: settings.tagline, announcement: settings.announcement, contact_email: settings.contact_email,
    moderation_required: settings.moderation_required, stripe_enabled: settings.stripe_enabled, mercadopago_enabled: settings.mercadopago_enabled,
  });
  const set = (k) => (v) => setF({ ...f, [k]: v?.target ? v.target.value : v });

  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <div className="glass space-y-4 rounded-xl p-6">
        <h2 className="font-display text-2xl font-black uppercase">Plataforma</h2>
        <div className="space-y-1.5"><Label>Nome do site</Label><Input data-testid="settings-site-name" value={f.site_name} onChange={set("site_name")} /></div>
        <div className="space-y-1.5"><Label>Slogan</Label><Input data-testid="settings-tagline" value={f.tagline} onChange={set("tagline")} /></div>
        <div className="space-y-1.5"><Label>Aviso no topo (deixe vazio para ocultar)</Label><Input data-testid="settings-announcement" value={f.announcement} onChange={set("announcement")} /></div>
        <div className="space-y-1.5"><Label>E-mail de contato</Label><Input data-testid="settings-contact-email" value={f.contact_email} onChange={set("contact_email")} /></div>
        <Toggle testId="settings-moderation" label="Moderação obrigatória" hint="Novas fotos só aparecem após sua aprovação" checked={f.moderation_required} onChange={set("moderation_required")} />
      </div>
      <div className="glass space-y-4 rounded-xl p-6">
        <h2 className="font-display text-2xl font-black uppercase">Pagamentos</h2>
        <Toggle testId="settings-stripe-enabled" label="Stripe (cartão)" hint="Modo de teste ativo — reivindique sua conta para receber" checked={f.stripe_enabled} onChange={set("stripe_enabled")} />
        <Toggle testId="settings-mercadopago-enabled" label="Mercado Pago (Pix, boleto, cartão)" hint="Exige o Access Token do Mercado Pago" checked={f.mercadopago_enabled} onChange={set("mercadopago_enabled")} />
        <div data-testid="settings-mp-status" className={`flex items-center gap-2 rounded-xl p-4 text-sm ${mpConfigured ? "bg-lime-400/10 text-lime-300" : "bg-yellow-400/10 text-yellow-300"}`}>
          {mpConfigured ? <CheckCircle2 className="h-4 w-4" /> : <AlertTriangle className="h-4 w-4" />}
          {mpConfigured ? "Mercado Pago conectado" : "Mercado Pago aguardando credenciais"}
        </div>
      </div>
      <button data-testid="settings-save-btn" onClick={() => onSave(f)} className="btn-neon rounded-full py-3.5 font-semibold lg:col-span-2">Salvar configurações</button>
    </div>
  );
};
